exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".text-input{border:0;border-bottom:1px dotted #ccc;padding:7px 10px;width:100%}a{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./app/admin/tipificacion/formulario.component.css
// module id = 467
// module chunks = 0